<template>
  <tr :active="props.selected" @click.stop="bus.$emit('clickRow',props)">
    <td>
      <v-checkbox v-model="props.selected" primary hide-details @click.stop="props.selected = !props.selected">
      </v-checkbox>
    </td>
    <td v-for="header in Headers" :class="getCellClass(header)">
      <slot :name="'table-cell-'+header.value" :props="props" :header="header" :row-options="options">
        <data-cell :props="props" :header="header" :row-options="options"></data-cell>
      </slot>
    </td>
  </tr>
</template>

<style scoped>

</style>

<script>
  import DataRow from "./dataRow.ts";
  export default DataRow;
</script>